import * as Color from './colors.style';
import * as FontSize from './fontSizes.style';
import Screen from './mediaQueries.style';

export { Color, FontSize, Screen };


// WEBPACK FOOTER //
// ./src/utils/styles/theme/index.js